import React from "react";
import Form from "../../componets/Form";

export default function Section11() {
  return (
    <div id="contact" className="w-full Section11">
      <div className="w-[90%] md:w-[70%] mx-auto text-center pt-[30px] pb-[2%]">
        <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
          Ready to Build a Shopify Plus Store That Supports Your Growth?
        </h2>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
          Mean3 can help you plan and build the right solution. Whether you
          are starting a new ecommerce business, switching from another
          platform, or upgrading your Shopify store, we are here to assist.
        </p>
        <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-4">
          Our team will understand your business requirements, recommend the
          best development approach, and create a Shopify Plus store that is
          built for long-term success.
        </p>
        <p className="leading-[22px] text-[#DA2128] font-bold text-sm md:text-base font-open mb-8">
          <a href="/contact-mean3">Talk to our Shopify Plus experts today and schedule a consultation to discuss your project.</a>
        </p>
      </div>

      {/* <div className="mt-[20px]">
        <Form />
      </div> */}
    </div>
  );
}